import React, { useEffect, useState } from 'react'
import { Button, Grid, RadioGroup, Snackbar } from '@material-ui/core'
import { Alert } from '@material-ui/lab'

import SteppedContent from '../common/SteppedContent'
import { pushSnowplow, toUserUnboardingProcessSchema } from '../../util/snowplow'
import {
  CLICKED_NEXT,
  SELECTED_DAILY_EMAIL_TIME,
  VIEWED_INFORMATIONAL_SNACKBAR,
} from '../../util/events/onboardingEvents'
import { ONBOARDING_STEPS } from './onboardingUtils'
import FormControlItem from './FormControlItem'

const options = Object.freeze({
  SIX: '06:00:00',
  EIGHT: '08:00:00',
  NINE: '09:00:00',
})

const StepEmailSendTime = ({ setCurrentStep, updateUserProgressStart, showSnackbar }) => {
  const [dailyEmailSendTime, setDailyEmailSendTime] = useState(options.SIX)

  useEffect(() => {
    if (showSnackbar) {
      pushSnowplow(
        toUserUnboardingProcessSchema(
          VIEWED_INFORMATIONAL_SNACKBAR,
          ONBOARDING_STEPS.EMAIL_SEND_TIME.name,
        ),
      )
    }
  }, [showSnackbar])

  const handleChange = event => {
    setDailyEmailSendTime(event.target.value)
    pushSnowplow(
      toUserUnboardingProcessSchema(
        SELECTED_DAILY_EMAIL_TIME,
        ONBOARDING_STEPS.EMAIL_SEND_TIME.name,
        event.target.value,
      ),
    )
  }

  const handleSubmit = () => {
    updateUserProgressStart({ dailyEmailSendTime })
    pushSnowplow(toUserUnboardingProcessSchema(CLICKED_NEXT, ONBOARDING_STEPS.EMAIL_SEND_TIME.name))
    setCurrentStep(ONBOARDING_STEPS.CUISINE_TYPES)
  }

  return (
    <SteppedContent
      title="Set your notification preference"
      description="We'll send you an email each morning letting you know which restaurants are delivering
        that day. What time should we send your email?"
      progressText={`Step ${ONBOARDING_STEPS.EMAIL_SEND_TIME.value} of 3`}
      action={
        <Button variant="contained" color="primary" onClick={handleSubmit}>
          Next
        </Button>
      }
    >
      <RadioGroup row name="dailyEmailSendTime" value={dailyEmailSendTime} onChange={handleChange}>
        <Grid component="fieldset" container justify="space-between">
          <Grid item xs={3}>
            <FormControlItem
              type="radio"
              value={options.SIX}
              checked={dailyEmailSendTime === options.SIX}
              label="6:00 am"
            />
          </Grid>
          <Grid item xs={3}>
            <FormControlItem
              type="radio"
              value={options.EIGHT}
              checked={dailyEmailSendTime === options.EIGHT}
              label="8:00 am"
            />
          </Grid>
          <Grid item xs={3}>
            <FormControlItem
              type="radio"
              value={options.NINE}
              checked={dailyEmailSendTime === options.NINE}
              label="9:00 am"
            />
          </Grid>
        </Grid>
      </RadioGroup>
      <Snackbar open={showSnackbar}>
        <Alert severity="info" variant="filled">
          We carefully select popular local and national restaurant partners to join Foodsby. The
          list of restaurant options changes each day in order to keep things fresh.
        </Alert>
      </Snackbar>
    </SteppedContent>
  )
}

export default StepEmailSendTime
